module.exports = __webpack_public_path__ + "img/L_305_0.9762c384.png";